import { ref } from 'vue'
import { AxiosResponse } from 'axios'

export type TRequestsInfoStateData = {
    url: string
    duration: number
    widgetId: number
}

const RequestsInfoState = ref<Array<TRequestsInfoStateData>>([])

function setRequestInfoState (data: TRequestsInfoStateData) {
    const _data = [ ...RequestsInfoState.value ]
    const indexOfElement = _data.findIndex(el => el.url === data.url)
    if (indexOfElement !== -1) {
        _data[indexOfElement].duration = data.duration
    } else {
        _data.push(data)
    }
    updateRequestInfo(_data)
}
function updateRequestInfo (data: Array<TRequestsInfoStateData>) {
    RequestsInfoState.value = [ ...data ]
}
export function setRequestInfo (axiosResponse: AxiosResponse) {
    const currentTime = new Date().getTime()
    const startTime = axiosResponse.config.headers?.RequestStartTime || 0
    const requestDuration = currentTime - +startTime
    const url = axiosResponse.config.url || ''
    if (url.includes('WidgetsData/')) {
        const regExpRule = /\/(?:[0-9]\/|[0-9])+$/gm
        const widgetData = url.match(regExpRule)?.map(el => el.replace('/', ''))
        const widgetId = widgetData ? widgetData[0] : undefined
        if (widgetId !== undefined) {
            setRequestInfoState({
                url: url,
                duration: requestDuration,
                widgetId: Number(widgetId)
            })
        }
    }
}


export function clearRequestInfo () {
    RequestsInfoState.value = []
}

export function getRequestsInfo () {
    return RequestsInfoState.value
}
export function getRequestsInfoByWidgetId (widgetId: number) {
    return getRequestsInfo().find(i => i.widgetId === widgetId)
}
